import { forwardRef } from 'react';
import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';

type LinkProps = Omit<RouterLinkProps, 'to'> & { href: string };
const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ href, ...rest }, ref) => (
	<RouterLink ref={ref} to={href} {...rest} />
));
Link.displayName = 'Link';
export default Link;
